__turbopack_context__.v({
  "bgColor_mainDarkest": "heading-module-scss-module__kemyla__bgColor_mainDarkest",
  "bgColor_mainLightest": "heading-module-scss-module__kemyla__bgColor_mainLightest",
  "bgColor_mainSecondary": "heading-module-scss-module__kemyla__bgColor_mainSecondary",
  "bgColor_neutralDark": "heading-module-scss-module__kemyla__bgColor_neutralDark",
  "bgColor_neutralLight": "heading-module-scss-module__kemyla__bgColor_neutralLight",
  "bgColor_neutralMedium": "heading-module-scss-module__kemyla__bgColor_neutralMedium",
  "fontColor_error": "heading-module-scss-module__kemyla__fontColor_error",
  "fontColor_mainDarkest": "heading-module-scss-module__kemyla__fontColor_mainDarkest",
  "fontColor_mainLightest": "heading-module-scss-module__kemyla__fontColor_mainLightest",
  "fontColor_mainPrimary": "heading-module-scss-module__kemyla__fontColor_mainPrimary",
  "fontColor_mainSecondary": "heading-module-scss-module__kemyla__fontColor_mainSecondary",
  "fontColor_neutralDark": "heading-module-scss-module__kemyla__fontColor_neutralDark",
  "fontColor_neutralLight": "heading-module-scss-module__kemyla__fontColor_neutralLight",
  "fontColor_neutralMedium": "heading-module-scss-module__kemyla__fontColor_neutralMedium",
  "fontFamily_accent": "heading-module-scss-module__kemyla__fontFamily_accent",
  "fontFamily_primary": "heading-module-scss-module__kemyla__fontFamily_primary",
  "fontFamily_secondary": "heading-module-scss-module__kemyla__fontFamily_secondary",
  "fontSize_extraLarge": "heading-module-scss-module__kemyla__fontSize_extraLarge",
  "fontSize_extraSmall": "heading-module-scss-module__kemyla__fontSize_extraSmall",
  "fontSize_large": "heading-module-scss-module__kemyla__fontSize_large",
  "fontSize_medium": "heading-module-scss-module__kemyla__fontSize_medium",
  "fontSize_small": "heading-module-scss-module__kemyla__fontSize_small",
  "fontSize_tiny": "heading-module-scss-module__kemyla__fontSize_tiny",
  "heading": "heading-module-scss-module__kemyla__heading",
});
